import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { selectOptionsCryptoCurrencies } from 'src/store/slice/payment/state';
import { useAppContext } from 'src/context/useAppContext';

import Dropdown, { IField } from 'src/components/dropdown';
import Icon from '../icon';

const DropdownCurrency: React.FC = (): JSX.Element => {
  const { t }: any = useTranslation();
  const { currency, setCurrency } = useAppContext();

  const optionsCryptoCurrencies = useSelector(selectOptionsCryptoCurrencies);

  const onSetCurrency = (option: IField) => {
    const { value } = option;

    setCurrency({ currency_id: value.split(' ')[0], network: value.split(' ')[1] });
  };

  const optionsCryptoCurrenciesWithIcon = optionsCryptoCurrencies?.map((option) => ({
    ...option,
    icon: <Icon currencyId={option.value.split(' ')[0].toLowerCase()} />,
  }));

  return (
    <Dropdown
      label={t('LABEL.CURRENCY')}
      selectedValue={`${currency?.currency_id} ${currency?.network}`}
      onChange={onSetCurrency}
      options={optionsCryptoCurrenciesWithIcon || []}
    />
  );
};

export default DropdownCurrency;
